export const CATEGORY = {
    MOVIE: 'movie',
    SONG: 'song',
    VIDEO: 'video',
    REELS: 'reels',
    INFLUENCER: 'influencer',
}

export const CATEGORY_RULES = {
    MOVIE: { 
        BOX_OFFICE_COLLECTION: true,
        VIEW_COUNT: false,
        LIKES_COUNT: false,
        RANK: false,
        STREAM_COUNT: false,
        COMMENTS: false,
        SHARES: false,
        FOLLOWERS_COUNT: false,
    },
    SONG: { 
        BOX_OFFICE_COLLECTION: false,
        VIEW_COUNT: false,
        LIKES_COUNT: false,
        RANK: true,
        STREAM_COUNT: true,
        COMMENTS: false,
        SHARES: false,
        FOLLOWERS_COUNT: false,
    },
    VIDEO: { 
        BOX_OFFICE_COLLECTION: false,
        VIEW_COUNT: true,
        LIKES_COUNT: false,
        RANK: false,
        STREAM_COUNT: false,
        COMMENTS: false,
        SHARES: false,
        FOLLOWERS_COUNT: false,
    },
    REELS: { 
        BOX_OFFICE_COLLECTION: false,
        VIEW_COUNT: true,
        LIKES_COUNT: false,
        RANK: false,
        STREAM_COUNT: false,
        COMMENTS: true,
        SHARES: true,
        FOLLOWERS_COUNT: false,
        UPLOAD_COUNT: false,
    },
    INFLUENCER: { 
        BOX_OFFICE_COLLECTION: false,
        VIEW_COUNT: true,
        LIKES_COUNT: true,
        RANK: false,
        STREAM_COUNT: false,
        COMMENTS: false,
        SHARES: false,
        FOLLOWERS_COUNT: true,
        UPLOAD_COUNT: true,
    },
}

export const GAME_TYPE = {
    //PREDICT_BASED: 'predictionBased',
    FANTASY_LEAGUE_GAME: 'FLReal',
    //SPIN_THE_WHEEL: 'spinTheWheel',
    //RAPID_FIRE: 'rapidFire',
    //MEMORY_CHALLENGE: 'memoryChallenge',
};
Object.freeze(GAME_TYPE);
export const GAME_TYPE_ARRAY = Object.entries(GAME_TYPE).map(([key, value]) => ({
    value,
    label: value.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase()),
}));
export const matchedGameTypeLabel = (inputType) => GAME_TYPE_ARRAY.find(
  ({ value }) =>
    value.replace(/_/g, '').toLowerCase() === inputType.replace(/_/g, '').toLowerCase()
)?.label;

export const RATIO_OPTIONS = [
  { label: "None", value: "", width: 0, height: 0 },  
  { label: "1:1 (Square)", value: "1:1", width: 1, height: 1 },
  { label: "4:3 (Standard)", value: "4:3", width: 4, height: 3 },
  { label: "3:4 (Portrait)", value: "3:4", width: 3, height: 4 },
  { label: "16:9 (Widescreen)", value: "16:9", width: 16, height: 9 },
  { label: "9:16 (Vertical Video)", value: "9:16", width: 9, height: 16 },
  { label: "21:9 (Cinema)", value: "21:9", width: 21, height: 9 },
  { label: "2:3 (Poster)", value: "2:3", width: 2, height: 3 },
  { label: "3:2 (Classic Photo)", value: "3:2", width: 3, height: 2 },
];

export const ANCHOR_TYPE = {
    SHOW: 'show',
    SUB_CATEGORY:'sub-category',
}
Object.freeze(ANCHOR_TYPE);
export const ANCHOR_TYPE_ARRAY = Object.entries(ANCHOR_TYPE).map(([key, value]) => ({
    value,
    label: value.toLowerCase(),
}));

export const GAME_STATUS = {
    QUEUED: 'queued',
    ACTIVE: 'active',
    EXPIRED: 'expired',
}
Object.freeze(GAME_STATUS);
export const GAME_STATUS_ARRAY = Object.entries(GAME_STATUS).map(([key, value]) => ({
    value,
    label: value.toLowerCase().replace(/\b\w/g, c => c),
}));

export const TIME_TYPE = {
    GO_LIVETIME: 'GO_LIVE_TIME',
    RESULT_DECLARE_TIME: 'RESULT_DECLARE_TIME',
    SUBMISSION: 'SUBMISSION_TIME',
    LOBBY_TIME: 'LOBBY_TIME',
}
Object.freeze(TIME_TYPE);
export const TIME_TYPE_ARRAY = Object.entries(TIME_TYPE).map(([key, value]) => ({
    value,
    label: value.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase()),
}));

export const CONTEST_TYPE = {
    PRACTICE: 'Practice',
    PAID : 'Paid',
}
Object.freeze(CONTEST_TYPE);
export const CONTEST_TYPE_ARRAY = Object.entries(CONTEST_TYPE).map(([key, value]) => ({
    value,
    label: value.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase()),
}));

